import { render, staticRenderFns } from "./contract-list.vue?vue&type=template&id=b72fb330&scoped=true&"
import script from "./contract-list.vue?vue&type=script&lang=js&"
export * from "./contract-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72fb330",
  null
  
)

export default component.exports